import React, { useEffect, useState } from "react";
import InputAHSF from "../../Components/InputAHSF";
import "./style.css";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";

import AllDropDownsAHSF from "../../Components/AllDropDownsAHSF";
import PopupAHSF from "../../Components/PopupAHSF";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { useDispatch, useSelector } from "react-redux";
import { GetAccountUserAssigning } from "../../Redux/Reducers/AccountUserAssignin";
import { useNavigate } from "react-router-dom";
import {
  AssigningSubTask,
  CreateSubTaskFlow,
} from "../../Redux/Reducers/SubTaskFlow";
import { GetHeaderTaskPageData } from "../../Redux/Reducers/HeaderTaskPageData";
import LoaderAHSF from "../../Components/LoaderAHSF";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import { useCookies } from "react-cookie";
import TableLog from "../TableLog";
import { jwtDecode } from "jwt-decode";

const SingleTaskManager = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies([]);
  const [taskList, setTaskList] = useState(props.tasks);
  const [loading, setLoading] = useState(false);
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [dropDownListEvalNames, setdropDownListEvalNames] = useState([]);
  const [dropDownListEvalID, setdropDownListEvalID] = useState([]);
  const [dropDownSearchStatus, setdropDownSearchStatus] = useState(false);
  const [taskGUID, settaskGUID] = useState();
  const [userGuid, setuserGuid] = useState();
  const [issiningMainTask, setissiningMainTask] = useState();
  const [multiFlowLimit, setmultiFlowLimit] = useState();
  const [LimitMassage, setLimitMassage] = useState(false);
  const [wF_SubTaskFlowList, setwF_SubTaskFlowList] = useState();
  const state = useSelector((state) => {
    return {
      AccountUserAssigning: state.AccountUserAssigning.AccountUserAssigning,
      RoleByUserGuid: state.RoleByUserGuid.RoleByUserGuid,
      HeaderTaskPageData: state.HeaderTaskPageData.HeaderTaskPageData,
      loadingHeaderTaskPageData:
        state.HeaderTaskPageData.loadingHeaderTaskPageData,
      UserInfo: state.UserInfo.UserInfo,
    };
  });
  //   console.log(state.UserInfo, "yuyuyyuyuyuyuyu");
  let userInfoData = jwtDecode(cookies.loginTokenSSO);

  //[,]
  //this method to تشفير ال param
  const encodeParam = (param) => btoa(param);
  //[,]
  // Handle main task click
  const handleTaskClick = async (
    flowGUID,
    user,
    isByAssignFlow,
    wF_SubTaskFlowList,
    multiFlowLimit,
    taskFlowGUID,
    taskStatusGUID,
    flowPermissionList
  ) => {
    //[,]
    //to check on role user on flow
    const hasCommonElements = flowPermissionList?.some((item) =>
      state.RoleByUserGuid.includes(item)
    );
    settaskGUID(taskFlowGUID);
    setissiningMainTask(false);
    setdropDownListEvalNames([]);
    setdropDownListEvalID([]);
    setLimitMassage(false);
    setmultiFlowLimit(multiFlowLimit);
    setwF_SubTaskFlowList([...wF_SubTaskFlowList]);
    //[,]
    //to get dropdown list users
    await dispatch(
      GetAccountUserAssigning({
        flowGUID: flowGUID,
        canMainTaskFlow: user ? (isByAssignFlow ? false : true) : true,
      })
    );
   

    if (
      //   state.RoleByUserGuid.includes("2e2f0a6c-54b0-4eb2-8741-55b23282a790") &&
      hasCommonElements &&
      user
    ) {
      //[,]
      //   اذا كان نفس الشخص المسؤؤل  وisByAssignFlow =true
      //ولم يتجاوز الlimit
      //يستطيع ان يضيف محكمين ولمرة واحدة في حال كان حالة المهمة مفتوحه
      //غير ذلك ينقله الى صفحه المهمة
      if (userInfoData?.UserGuid == user) {
        if (isByAssignFlow) {
          if (
            wF_SubTaskFlowList.length != 0 &&
            wF_SubTaskFlowList.length <= multiFlowLimit
          ) {
            // navigate()

            navigate(
              `/grants/manager/AllComponentPageMainTask/${encodeParam(
                flowGUID
              )}/${encodeParam(taskFlowGUID)}/${encodeParam(
                taskStatusGUID
              )}/${encodeParam(user)}`
            );
          } else {
            if (
              taskStatusGUID == "549bd041-23ad-491a-a6f6-6633acc29190" &&
              hasCommonElements
            ) {
              setPopUpBodyOPjectDataStatus(true);
              setdropDownSearchStatus(true);
            }
          }
        } else {
          // navigate()
          navigate(
            `/grants/manager/AllComponentPageMainTask/${encodeParam(
              flowGUID
            )}/${encodeParam(taskFlowGUID)}/${encodeParam(
              taskStatusGUID
            )}/${encodeParam(user)}`
          );
        }
      } else {
        navigate(
          `/grants/manager/AllComponentPageMainTask/${encodeParam(
            flowGUID
          )}/${encodeParam(taskFlowGUID)}/${encodeParam(
            taskStatusGUID
          )}/${encodeParam(user)}`
        );
      }
    } else if (
      !user &&
      taskStatusGUID == "549bd041-23ad-491a-a6f6-6633acc29190" &&
      //   !state.RoleByUserGuid.includes("fd21937f-89d0-442e-8010-5b88e360bd48")
      hasCommonElements
    ) {
      setPopUpBodyOPjectDataStatus(true);
      setdropDownSearchStatus(false);
    } else {
        if (
          !state.RoleByUserGuid.includes("fd21937f-89d0-442e-8010-5b88e360bd48")
        ) {
      navigate(
        `/grants/manager/AllComponentPageMainTask/${encodeParam(
          flowGUID
        )}/${encodeParam(taskFlowGUID)}/${encodeParam(
          taskStatusGUID
        )}/${encodeParam(user)}`
      );
        }
    }
  };
  //[,]
  // Handle sub-task click
  const handleSubtaskClick = async (
    flowGUID,
    user,
    subTaskFlowGUID,
    taskFlowGUID,
    taskStatusGUID,
    mainTaskStatus,
    flowPermissionList
  ) => {
    // console.log(flowPermissionList,"flowPermissionList");
    
    const hasCommonElements = flowPermissionList?.some((item) =>
      state.RoleByUserGuid.includes(item)
    );

    settaskGUID(subTaskFlowGUID);
    setissiningMainTask(true);
    setdropDownSearchStatus(false);
    setdropDownListEvalNames([]);
    setdropDownListEvalID([]);
    //[,]
    //to get dropdown users data
    await dispatch(
      GetAccountUserAssigning({
        flowGUID: flowGUID,
        canMainTaskFlow: false,
      })
    );

    if (
      
      hasCommonElements &&
      !user
    ) {
      //if status open and role in this task 
      if (
        mainTaskStatus == "549bd041-23ad-491a-a6f6-6633acc29190" &&
        hasCommonElements
      ) {
        setPopUpBodyOPjectDataStatus(true);
      } else {
        navigate(
          `/grants/manager/AllComponentPage/${encodeParam(
            flowGUID
          )}/${encodeParam(subTaskFlowGUID)}/${encodeParam(taskFlowGUID)}`
        );
      }
    } else {
      navigate(
        `/grants/manager/AllComponentPage/${encodeParam(
          flowGUID
        )}/${encodeParam(subTaskFlowGUID)}/${encodeParam(taskFlowGUID)}`
      );
    }
  };
  //[,]
  //this function on click on assign button to add user to task
  const onAssigningTask = async () => {
    //console.log(dropDownSearchStatus, dropDownListEvalID, "dropDownListEvalID");
    setLoading(true);

    if (dropDownSearchStatus) {
      if (
        dropDownListEvalID.length + wF_SubTaskFlowList.length <=
        multiFlowLimit
      ) {
        setLimitMassage(false);

        const success = await dispatch(
          CreateSubTaskFlow({
            taskGuid: taskGUID,
            uS_UserList: dropDownListEvalID,
          })
        );
        // console.log(success, "success");
//if success close popup and refresh
        if (success) {
          setLoading(false);
          setPopUpBodyOPjectDataStatus(false);
          dispatch(setRefreshTable());
        }
      } else {
        setLoading(false);
        setLimitMassage(true);
      }
    } else {
      //to get user can be assining
      const success = await dispatch(
        AssigningSubTask({
          taskGUID: taskGUID,
          issiningMainTask: issiningMainTask,
          userGuid: userGuid,
        })
      );
      if (success) {
        setLoading(false);

        setPopUpBodyOPjectDataStatus(false);
        dispatch(setRefreshTable());
      }
    }
    //console.log(userGuid, taskGUID, "taskGUID");
  };
  //[,]
  //to change assigining user if stats on task open
  const editeAssigningUser = async (
    flowGUID,
    mainTaskStatus,
    canMainTaskFlow,
    taskFlowGuid,
    subTaskStatusGUID
  ) => {

    setdropDownSearchStatus(false);
    // console.log(subTaskStatusGUID, "subTaskStatusGUID");
    //[,]
    //for subTask canMainTaskFlow: false,
    if (subTaskStatusGUID) {
      if (
        mainTaskStatus == "549bd041-23ad-491a-a6f6-6633acc29190" &&
        subTaskStatusGUID != "b8207a91-b6c1-4284-89c7-3acd8a492875"
      ) {
        settaskGUID(taskFlowGuid);
        setissiningMainTask(true);
        //[,]
        //get users list by flow
        const getusers = await dispatch(
          GetAccountUserAssigning({
            flowGUID: flowGUID,
            canMainTaskFlow: false,
          })
        );
        //console.log(getusers);

        if (getusers.payload) {
          setPopUpBodyOPjectDataStatus(true);
        }
      }
    } else {
      //[,]
      //for main canMainTaskFlow: true,
      if (mainTaskStatus == "549bd041-23ad-491a-a6f6-6633acc29190") {
        settaskGUID(taskFlowGuid);
        setissiningMainTask(false);

        const getusers = await dispatch(
          GetAccountUserAssigning({
            flowGUID: flowGUID,
            canMainTaskFlow: true,
          })
        );
        //console.log(getusers);

        if (getusers.payload) {
          setPopUpBodyOPjectDataStatus(true);
        }
      }
    }
  };
  //console.log(taskList, "taskList");
  const itemsPerPage = 5; // عدد العناصر لكل صفحة
  const [currentPage, setCurrentPage] = useState(0);
  //[,]
  // التعامل مع تغيير الصفحة
  const handlePageChange = (data) => {
    setCurrentPage(data.selected);
  };
  //console.log(dropDownListEvalID, "AccountUserAssigning");
  //[,]
  // حساب الفهرس للبداية والنهايةpagenition
  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentTasks = taskList && taskList.slice(startIndex, endIndex);
  //-----------------------------------------------------------------------------------
  //[,]
  //to get data for application info
  useEffect(() => {
    dispatch(
      GetHeaderTaskPageData(
        localStorage.getItem("aI_ApplicationInformationId_Manager")
      )
    );
  }, []);
  //[,]
  //popup body to assgin subtask to user
  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        {/* [,] */}
        {/* if flow isByAssignFlow = true */}
        {/* لاظهار المحكمين */}
        {dropDownSearchStatus ? (
          <>
            <span style={{ color: "red", fontSize: "16px", fontWeight: "600" }}>
              يرجى اختيار المحكمين وبحد اقصى {multiFlowLimit}{" "}
            </span>{" "}
            <AllDropDownsAHSF
              fieldsName="yesNoTableDropDown"
              show={true}
              hidelable={true}
              disabled={false}
              arrayOoptionList={state.AccountUserAssigning}
              KeyText={"fullName"}
              id={"uS_UserGuid"}
              dropdownType={"search"}
              OnClickLi={(e) => {
                //console.log(e, "e.target");
                if (!dropDownListEvalNames.includes(e.fullName)) {
                  if (dropDownListEvalNames.length <= multiFlowLimit) {
                    setdropDownListEvalNames([
                      ...dropDownListEvalNames,
                      e.fullName,
                    ]);
                  } else {
                  }
                }
                if (!dropDownListEvalID.includes(e.uS_UserGuid)) {
                  if (dropDownListEvalID.length <= multiFlowLimit) {
                    setdropDownListEvalID([
                      ...dropDownListEvalID,
                      e.uS_UserGuid,
                    ]);
                  }
                }
              }}
              //   defaultValue={AdvertisingList.mP_MR_ItemId}
            />
          </>
        ) : (
          //[,]
          //if flow isByAssignFlow = false
          // لاظهار الموظفين

          <AllDropDownsAHSF
            fieldsName="yesNoTableDropDown"
            show={true}
            hidelable={true}
            disabled={false}
            arrayOoptionList={state.AccountUserAssigning}
            KeyText={"fullName"}
            KeyValue={"uS_UserGuid"}
            dropdownType={"normal"}
            onChange={(e) => {
              //console.log(e.target.value, "e.target");
              setuserGuid(e.target.value);
            }}
            //   defaultValue={AdvertisingList.mP_MR_ItemId}
          />
        )}
        <div>
          {/* [,] */}
          {/* لاظهار اسماء المحكمين واضافتهم الى القائمة في حال تم اختياره */}
          {dropDownListEvalNames.map((elem, i) => {
            return (
              <p style={{ display: "flex" }}>
                {elem}
                <span
                  style={{ color: "red", marginRight: "10px" }}
                  onClick={() => {
                    setdropDownListEvalNames(
                      dropDownListEvalNames.filter((elem, index) => index !== i)
                    );
                    setdropDownListEvalID(
                      dropDownListEvalID.filter((elem, index) => index !== i)
                    );
                  }}
                >
                  <li className="bi bi-trash" id="deleteBtn"></li>
                </span>
              </p>
            );
          })}
          {/* [,] */}
          {/* اظهار رسالة تنبيه في حال تم تجاوز العددد المسموح*/}
          {LimitMassage ? (
            <span style={{ color: "red", fontSize: "16px", fontWeight: "600" }}>
              تجاوزت العدد المسموح {multiFlowLimit}{" "}
            </span>
          ) : (
            ""
          )}
        </div>
        <div className="containersButton" style={{ marginTop: "10%" }}>
          <div>
            <ButtonAHSF
              type={"submitter"}
              onClick={() => {
                onAssigningTask();
              }}
              disabled={false}
              title={"إضافة"}
              text={"إضافة"}
              show={true}
            />
          </div>
        </div>
        <LoaderAHSF show={loading} />
      </div>
    ),
    title: "تعيين ",
    maxWidth: "500px",
    maxHeight: "500px",
  };
  return (
    <>
      <div className="form-grid">
        <InputAHSF
          fieldsName="ApplicationNumberInput"
          show={true}
          disabled={true}
          value={state.HeaderTaskPageData?.applicationNumber}
        />
        <InputAHSF
          fieldsName="M_ProjectName"
          show={true}
          disabled={true}
          value={state.HeaderTaskPageData?.projectName}
        />
        <InputAHSF
          fieldsName="M_ApplicantName"
          show={true}
          disabled={true}
          value={state.HeaderTaskPageData?.applicantNem}
        />
      </div>

      <table className="TasksTable">
        <thead>
          <tr className="header">
            <th></th>
            <th>المهمة</th>
            <th>المهمة الفرعية</th>
            <th>حالة المهمة</th>
            <th>الشخص المسؤول</th>
          </tr>
        </thead>
        <tbody>
          {currentTasks &&
            currentTasks.map((task, index) => (
              <React.Fragment key={task.taskFlowGUID}>
                {/* Main Task */}
                <tr className="row">
                  <td>{startIndex + index + 1}</td>
                  <td>
                    <span
                      className="link"
                      onClick={(e) => {
                        handleTaskClick(
                          task.flowGUID,
                          task.actionUserGUID,
                          task.isByAssignFlow,
                          task.wF_SubTaskFlowList,
                          task.multiFlowLimit,
                          task.taskFlowGUID,
                          task.taskStatusGUID,
                          task.flowPermissionList
                        );
                      }}
                      style={{ cursor: "pointer", color: "blue" }}
                    >
                      {task.taskType}
                    </span>
                    {task.taskStatusGUID ==
                      "549bd041-23ad-491a-a6f6-6633acc29190" &&
                    task.flowGUID == "6310803f-9c2e-4b7d-b8b8-35451a4ebc99" &&
                    task.wF_SubTaskFlowList.length < task.multiFlowLimit &&
                    task.flowPermissionListSubTask?.some((item) =>
                      state.RoleByUserGuid.includes(item)
                    ) ? (
                      <button
                        id="editBtn"
                        onClick={async () => {
                          settaskGUID(task.taskFlowGUID);
                          setissiningMainTask(false);
                          setdropDownListEvalNames([]);
                          setdropDownListEvalID([]);
                          setLimitMassage(false);
                          setmultiFlowLimit(task.multiFlowLimit);
                          setwF_SubTaskFlowList([...task.wF_SubTaskFlowList]);

                          //[,]
                          //to get dropdown users data
                          await dispatch(
                            GetAccountUserAssigning({
                              flowGUID: task.flowGUID,
                              canMainTaskFlow: false,
                            })
                          );

                          setPopUpBodyOPjectDataStatus(true);
                          setdropDownSearchStatus(true);
                        }}
                      >
                        <li
                          className="bi bi-pencil-square"
                          id="liMainTask"
                        ></li>
                      </button>
                    ) : (
                      ""
                    )}
                  </td>
                  <td>-</td>
                  <td>{task.taskStatusName}</td>
                  <td>
                    <div id="withEditeIcone">
                      {task.userName && task.userName != " "
                        ? task.userName
                        : "غير محدد"}
                      {task.taskStatusGUID ==
                        "549bd041-23ad-491a-a6f6-6633acc29190" &&
                      task.flowPermissionList?.some((item) =>
                        state.RoleByUserGuid.includes(item)
                      ) ? (
                        <button
                          id="editBtn"
                          onClick={() => {
                            editeAssigningUser(
                              task.flowGUID,
                              task.taskStatusGUID,
                              true,
                              task?.taskFlowGUID
                            );
                          }}
                        >
                          <li className="bi bi-pencil-square"></li>
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                </tr>
                {/* Subtasks */}
                {task.wF_SubTaskFlowList.map((subtask) => (
                  <tr className="subtaskRow" key={subtask.subTaskFlowGUID}>
                    <td>-</td>
                    <td
                      onClick={(e) => {
                        handleSubtaskClick(
                          subtask.taskFlow?.flow?.flowGUID,
                          subtask.userGUID,
                          subtask?.subTaskFlowGUID,
                          subtask?.taskFlowGUID,
                          subtask?.taskStatusGUID,
                          task.taskStatusGUID,
                          task.flowPermissionListSubTask
                        );
                      }}
                    >
                      <span
                        className="link"
                        id="sub"
                        onClick={() =>
                          handleSubtaskClick(
                            subtask.taskFlow?.flow?.flowGUID,
                            subtask.userGUID,
                            subtask?.subTaskFlowGUID,
                            subtask?.taskFlowGUID,
                            subtask?.taskStatusGUID,
                            task.taskStatusGUID,
                            task.flowPermissionListSubTask
                          )
                        }
                        style={{ cursor: "pointer", color: "blue" }}
                      >
                        {subtask.taskFlow?.flow?.flowName}
                      </span>
                    </td>
                    <td>{subtask.wfTaskStatus.taskStatusName}</td>
                    <td>
                      <div id="withEditeIcone">
                        {subtask.uS_User
                          ? `${subtask.uS_User.firstName} ${subtask.uS_User.lastName}`
                          : "غير محدد"}
                        {subtask?.taskStatusGUID ==
                          "549bd041-23ad-491a-a6f6-6633acc29190" &&
                        task.flowPermissionListSubTask?.some((item) =>
                          state.RoleByUserGuid.includes(item)
                        ) ? (
                          <button
                            id="editBtn"
                            onClick={() => {
                              editeAssigningUser(
                                subtask.taskFlow?.flow?.flowGUID,
                                task.taskStatusGUID,
                                false,
                                subtask?.subTaskFlowGUID,
                                subtask?.taskStatusGUID
                              );
                            }}
                          >
                            <li className="bi bi-pencil-square"></li>
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
        </tbody>
      </table>
      {!state.RoleByUserGuid.includes(
        "fd21937f-89d0-442e-8010-5b88e360bd48"
      ) ? (
        <TableLog />
      ) : (
        <></>
      )}
      <PopupAHSF
        isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
        isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
        title={popUpBodyOPjectData.title}
        componentBody={popUpBodyOPjectData.componentBody}
        maxWidth={popUpBodyOPjectData.maxWidth}
        maxHeight={popUpBodyOPjectData.maxHeight}
      />
      {/* <LoaderAHSF show={loading} /> */}
    </>
  );
};

export default SingleTaskManager;
